// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"236":"759bac8e","622":"6a9d128c","947":"a4c8d636","985":"6fe4a724"}[chunkId] + ".css";
};